import { z } from "zod";

import {
  teamMemberNamesAndEmailSchema,
  termsAndConditionsSchema,
} from "~/common/utils/signUpSchemas";
import { passwordSchema } from "./ProviderSchemas";

export const teamMemberSignUpSchema = z.object({
  namesAndEmail: teamMemberNamesAndEmailSchema,
  termsAndConditions: termsAndConditionsSchema,
  password: passwordSchema,
});

export type TeamMemberSignUpSchemaType = z.infer<typeof teamMemberSignUpSchema>;
